var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('router-link',{attrs:{"to":`${_vm.url}/${_vm.slug}`}},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),(_vm.item.children?.length)?_c('ul',_vm._l((_vm.item.children),function(children,i){return _c('BaseLink',{key:i,attrs:{"item":children,"url":_vm.fullUrl}})}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }